<template>
  <div>
    <div class="page-header clear-filter" filter-color="">
      <parallax
        class="page-header-image"
        style="background-image:url('img/facility/machine_hydraulic.jpg')"
      >
      </parallax>
      <div class="container">
        <h2 class="title mt-5">{{ $t('facilities.hero.title') }}</h2>
      </div>
    </div>
    <div class="section mt-n4 mb-4 justify-content-center">
      <div class="container">
        <h2 class="font-weight-bold">
          <img
            src="img/icon/icon (7).png" alt=""
            width="7%"
            class="ml-3 mr-3"
          />{{ $t('facilities.manufacturing.heading') }}
        </h2>
        <div class="facilities-container justify-content-center">
            <h5>
              {{ $t('facilities.manufacturing.intro') }}
            </h5>
          <div class="text-section">
            <table class="table table-responsive">
              <thead>
                <tr>
                  <th>{{ $t('facilities.manufacturing.table.headers.tools') }}</th>
                  <th>{{ $t('facilities.manufacturing.table.headers.dsc') }}</th>
                  <th>{{ $t('facilities.manufacturing.table.headers.edv') }}</th>
                  <th>{{ $t('facilities.manufacturing.table.headers.vyg') }}</th>
                  <th>{{ $t('facilities.manufacturing.table.headers.quantity') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ $t('facilities.manufacturing.table.rows.crane') }}</td>
                  <td>Up to 20/5 Ton</td>
                  <td>up to 30/10 Ton</td>
                  <td>10T</td>
                  <td>11</td>
                </tr>
                <tr>
                  <td>{{ $t('facilities.manufacturing.table.rows.hydraulicPress') }}</td>
                  <td>750 ton</td>
                  <td>-</td>
                  <td>-</td>
                  <td>1</td>
                </tr>
                <tr>
                  <td>{{ $t('facilities.manufacturing.table.rows.ncPressBreak') }}</td>
                  <td>-</td>
                  <td>220T</td>
                  <td>-</td>
                  <td>1</td>
                </tr>
                <tr>
                  <td>{{ $t('facilities.manufacturing.table.rows.rollsBending') }}</td>
                  <td>up to t 25mm</td>
                  <td>Up to t 40mm</td>
                  <td>-</td>
                  <td>5</td>
                </tr>
                <tr>
                  <td>{{ $t('facilities.manufacturing.table.rows.pipeBending') }}</td>
                  <td>Pipe up to NPS 4"</td>
                  <td>Pipe up to NPS 2.5"</td>
                  <td>-</td>
                  <td>2</td>
                </tr>
                <tr>
                  <td>{{ $t('facilities.manufacturing.table.rows.weldingMachines') }}</td>
                  <td>TIG, MIG/MAG/FCAW, Plasma, SAW, Orbital</td>
                  <td>TIG, MIG/MAG/FCAW, SMAW, SAW, Orbital</td>
                  <td>TIG</td>
                  <td>60</td>
                </tr>
                <tr>
                  <td>{{ $t('facilities.manufacturing.table.rows.cuttingMachines') }}</td>
                  <td>Shearing, CNC Plasma, Bandsaw</td>
                  <td>Shearing, CNC Plasma, Bandsaw</td>
                  <td>Plasma</td>
                  <td>8</td>
                </tr>
                <tr>
                  <td>{{ $t('facilities.manufacturing.table.rows.machineTools') }}</td>
                  <td>Lathe, Milling, Drilling</td>
                  <td>Lathe, Milling, Drilling</td>
                  <td>Drilling</td>
                  <td>14</td>
                </tr>
                <tr>
                  <td>{{ $t('facilities.manufacturing.table.rows.mobileGenset') }}</td>
                  <td>-</td>
                  <td>Genset 160kVA, Mobile Compressor 200CFM</td>
                  <td>Genset 40kVA</td>
                  <td>3</td>
                </tr>
                <tr>
                  <td>{{ $t('facilities.manufacturing.table.rows.inspectionTools') }}</td>
                  <td>XRF Alloy Analyzer, UT, MT, Boroscope, Hardness Test</td>
                  <td>XRF Alloy Analyzer, UT, MT, Boroscope, Hardness Test</td>
                  <td>-</td>
                  <td>13</td>
                </tr>
                <tr>
                  <td>{{ $t('facilities.manufacturing.table.rows.forklift') }}</td>
                  <td>Forklift upto 5T</td>
                  <td>Forklift up to 5T, Mobile Crane 25T, Truck Crane 5T</td>
                  <td>-</td>
                  <td>6</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="image-section">
             <!-- <img src="img/machine_hydraulic.jpg" alt="Manufacturing Machine"> -->
            <div class="" style="margin-top: 100px;">
              <h5>
                {{ $t('facilities.manufacturing.maxSize.note') }}<br><br>
                {{ $t('facilities.manufacturing.maxSize.maxDiameterLabel') }} &nbsp;&nbsp;:&nbsp;&nbsp; {{ $t('facilities.manufacturing.maxSize.maxDiameterValue') }}<br>
                {{ $t('facilities.manufacturing.maxSize.maxLengthLabel') }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;&nbsp; {{ $t('facilities.manufacturing.maxSize.maxLengthValue') }}<br>
                {{ $t('facilities.manufacturing.maxSize.overLimitNote') }}<br>
              </h5>
              <div class="mt-5" >
                <el-carousel height="450px">
                  <el-carousel-item>
                    <img class="d-block" src="img/facility/crane.jpg" alt="First slide" />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img class="d-block" src="img/facility/shearing1.jpg" alt="Second slide" />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img class="d-block" src="img/facility/machine_hydraulic.jpg" alt="Second slide" />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img class="d-block" src="img/facility/gatot_kaca.jpg" alt="Third slide" />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img class="d-block" src="img/facility/bending.jpg" alt="Third slide" />
                  </el-carousel-item>
                  <el-carousel-item>
                    <img class="d-block" src="img/facility/cutting.jpg" alt="Third slide" />
                  </el-carousel-item>
                  <!-- <el-carousel-item>
                    <img class="d-block" src="img/facility/machining.jpg" alt="Third slide" />
                  </el-carousel-item> -->
                </el-carousel>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="justify-content-center">
              <div class="">
                <el-carousel height="">
                  <el-carousel-item>
                    <img class="d-block" src="img/machine_hydraulic.jpg" alt="First slide" />
                    <div class="carousel-caption d-none d-md-block">
                      <h5 style="color: black;" class="font-weight-bold">ASME U Certificate</h5>
                    </div>
                  </el-carousel-item>
                  <el-carousel-item>
                    <img class="d-block" src="img/certification/iso.jpg" alt="Second slide" />
                    <div class="carousel-caption d-none d-md-block">
                      <h5 style="color: black;" class="font-weight-bold">ISO 9001 Certificate</h5>
                    </div>
                  </el-carousel-item>
                  <el-carousel-item>
                    <img class="d-block" src="img/certification/nb_auth.jpg" alt="Second slide" />
                    <div class="carousel-caption d-none d-md-block">
                      <h5 style="color: black;" class="font-weight-bold">NB Certificate of Authorization</h5>
                    </div>
                  </el-carousel-item>
                  <el-carousel-item>
                    <img class="d-block" src="img/certification/nb_r.jpg" alt="Third slide" />
                    <div class="carousel-caption d-none d-md-block">
                      <h5 style="color: black;" class="font-weight-bold">NB R Certificate of Authorization</h5>
                    </div>
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div> -->
      
    </div>

    <!-- MOTO TOKKI  -->
    <div class="page-header clear-filter moto-office-section" filter-color="purple">
      <div class="parallax">
        <div class="container" style="">
          <h1 class="text-white text-left pt-5 font-weight-bold text-center">START <span style="font-size: 20px; color: yellow;"> {{ $t('common.offices.motoStartWithTokki') }} </span></h1>
          <div class="row pt-5 mt-n4">
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.mainOfficeFactory') }}  :</span></h6>
              Kawasan Industri Jababeka 1
              Jl.Jababeka XIIB Blok W26
              Cikarang-Bekasi, Jawa Barat Indonesia Kode Pos 17530
              Telp: +62-21 893 6733 (Hunting) <br><br>

              Phone : +62 - 21 8936733 (Hunting)<br>
              Fax   : +62 - 21 8936738<br>
              Email : sales@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.secondOfficeFactory') }}</span></h6>
              Kawasan Industri Krakatau 1,
              Jl. Australia I Kav. C1/2, Kel. Warnasari, Kec. Citangkil
              Kota Cilegon, Banten - Indonesia 42443 <br><br>

              Phone : +62 - 254 8317244<br>
              Fax   : +62 - 254 8317244<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.thirdOfficeFactory') }}</span></h6>
              Pergudangan AKR GEM City F-09, Kabupaten Gresik, Jawa Timur <br><br><br>

              Phone : +62 - 31 39935914<br>
              Fax   : +62 - 31 39935914<br>
              Email : sales02@tef.co.id<br>
            </div>
            <div class="col-lg-3 text-left mb-5">
              <h6 class="text-white text-left font-weight-bold"><span style="color: #7FFF00;">{{ $t('common.offices.fourthMarketingOffice') }}</span></h6>
              Jl. Gn. Leuser, Tj. Marulak, Kec. Rambutan, Kota Tebing Tinggi, Sumatera Utara 20998 <br><br><br>

              Phone : +62 811-1972-2507<br>
              Email : sales@tef.co.id<br>
            </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import { Carousel, CarouselItem } from 'element-ui';

export default {
  name: 'profile',
  bodyClass: 'profile-page',
  components: {
    [Carousel.name]: Carousel,
    [CarouselItem.name]: CarouselItem
  },
  methods: {
    // toDetailProduct(param){
    //   this.$router.push('/detail-product/'+param)
    // }
  }
};
</script>
<style>
   .animated {
     
      padding-top:0px;
      margin-bottom:0px;
      -webkit-animation-duration: 5s;
      animation-duration: 5s;
      -webkit-animation-fill-mode: both;
      animation-fill-mode: both;
   }
   
   @-webkit-keyframes fadeInDown {
      0% {
         opacity: 0;
         -webkit-transform: translateY(-20px);
      }
      100% {
         opacity: 1;
         -webkit-transform: translateY(0);
      }
   }
   
   @keyframes fadeInDown {
      0% {
         opacity: 0;
         transform: translateY(-50px);
      }
      100% {
         opacity: 1;
         transform: translateY(0);
      }
   }
   
   .fadeInDown {
      -webkit-animation-name: fadeInDown;
      animation-name: fadeInDown;
   }


  .cards:hover{
    box-shadow: 5px 6px 6px 2px #e9ecef;
    transform: scale(1.1);
    cursor: pointer;;
  }
</style>
<style>
    body {
      font-family: Arial, sans-serif;
      background-color: #dedede;
      margin: 0;
    }

    .facilities-container {
      background-color: #00874B;
      border-radius: 24px;
      padding: 30px;
      color: white;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    .text-section {
      flex: 1;
      padding-right: 30px;
      min-width: 300px;
    }

    .text-section h2 {
      color: #007f4f;
      font-size: 24px;
      display: flex;
      align-items: center;
      margin-bottom: 10px;
    }

    .text-section h2::before {
      content: '⚙️';
      margin-right: 10px;
    }

    .text-section p {
      font-family: Arial, sans-serif;
      font-size: 14px;
      margin-bottom: 20px;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      background-color: white;
      color: black;
      border-radius: 18px;
      overflow: hidden;
      font-size: 12px;
    }

    th, td {
      padding: 10px 12px;
      border: 1px solid #00874B;
      text-align: left;
    }

    th {
      background-color: #ffffff;
      color: #00874B;
      font-weight: bold;
      text-align: center;
    }

    .footer-note {
      font-size: 13px;
      margin-top: 20px;
      color: #ffffff;
    }

    .image-section {
      flex: 1;
      min-width: 300px;
      /*display: flex;*/
      justify-content: center;
      align-items: center;
    }

    .image-section img {
      width: 100%;
      max-width: 600px;
      border-radius: 24px;
      box-shadow: 0 0 10px rgba(0,0,0,0.3);
    }

    @media (max-width: 768px) {
      .facilities-container {
        flex-direction: column;
        align-items: stretch;
      }

      .text-section {
        padding-right: 0;
      }
    }

    
  
.moto-office-section {
  max-height: none;
  height: auto;
  overflow: visible;
  padding-bottom: 40px;
}

.moto-office-section .parallax {
  height: auto;
  padding-bottom: 40px;
}
</style>
